
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExternalScriptsService {

  loadScript(options, onLoadCallback = null)  {
    const isFound = document.getElementById(options.id + '-script') !== null;

    if (!isFound) {
      const node = document.createElement('script');
      node.src = options.src;
      node.type = 'text/javascript';
      node.async = true;
      node.defer = true;
      node.charset = 'utf-8';
      node.id = options.id + '-script';
      document.getElementsByTagName('body')[0].appendChild(node);
      if(onLoadCallback) node.onload = onLoadCallback;
    }
  }

  removeScript(id) {
    // Create Element.remove() function if not exist
    if (!('remove' in Element.prototype as any)) {
     Element.prototype.remove = function() {
         if (this.parentNode) {
           this.parentNode.removeChild(this);
         }
     };
   }

   if (document.getElementById(id + '-script')) {
     document.getElementById(id + '-script').remove();
   }
  }

  podUiCleanup(id) {
    const container = document.getElementById(id);
      if (container) {
        container.remove();
      }
  }
}
